// Mirrored from phone repo: ../../workout/workout/src/config/exercise3d.ts
// Keep in sync manually for v1; extract to shared package in v1.1.

export type CameraAngle = 'front' | 'side' | 'back' | '45_front' | '45_back';

const MODEL_MAP: Record<string, string> = {
  'barbell back squat': 'squat',
  'bodyweight squats': 'squat',
  'barbell curl': 'bicep-curl',
  'hammer curl': 'bicep-curl',
  'mountain climbers': 'burpee',
  'jumping jacks': 'jumping-jack',
  'cable lateral raise': 'front-raises',
  'walking lunges': 'pistol-squat',

  'leg press': 'squat',
  'romanian deadlift': 'squat',
  'calf raises': 'squat',
  'barbell bench press': 'air-squat1',
  'dumbbell incline press': 'air-squat1',
  'overhead press': 'front-raises',
  'push-up (warm-up)': 'burpee',
  'barbell rows': 'bicep-curl',
  'dumbbell rows': 'bicep-curl',
  'lat pulldown': 'bicep-curl',
  'tricep dips': 'air-squat1',
  'band pull-aparts': 'front-raises',
  'band face pulls': 'front-raises',
  'bicycle crunches': 'burpee',
  'russian twists': 'burpee',
  'plank': 'idle',
  'dead bug': 'idle',
  'hanging leg raises': 'idle',
  'leg swings': 'jumping-jack',
  'arm circles': 'jumping-jack',

  'cat-cow stretch': 'idle',
  'cobra stretch': 'idle',
  "child's pose": 'idle',
  'chest doorway stretch': 'idle',
  'quad stretch': 'idle',
  'hamstring stretch': 'idle',
  'tricep overhead stretch': 'idle',
};

export const CHARACTER_MODEL = 'Swagger Walk';
export const IDLE_ANIMATION = 'idle';

const FALLBACK_ANIMATIONS = [
  'squat', 'bicep-curl', 'burpee', 'jumping-jack', 'front-raises', 'pistol-squat',
];

export const TEXTURE_NAME = 'texture_0';
export const TEXTURE_EXT = 'jpeg';

export const ANGLE_ROTATIONS: Record<CameraAngle, number> = {
  front: 0,
  side: Math.PI / 2,
  back: Math.PI,
  '45_front': Math.PI / 4,
  '45_back': (3 * Math.PI) / 4,
};

export function getModelForExercise(exerciseName: string): string {
  const mapped = MODEL_MAP[exerciseName.toLowerCase()];
  if (mapped) return mapped;

  let hash = 0;
  for (const ch of exerciseName) hash = (hash * 31 + ch.charCodeAt(0)) | 0;
  return FALLBACK_ANIMATIONS[Math.abs(hash) % FALLBACK_ANIMATIONS.length];
}
